import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white text-black p-4">
      <div className="flex justify-center items-center space-x-4">
        <p> Copy-right By @Keymanz
        </p>
        {/* <a
          href="https://www.facebook.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Facebook_Logo_%282019%29.png/480px-Facebook_Logo_%282019%29.png"
            alt="Facebook Logo"
            className="h-8 w-8"
          />
        </a>
        <a
          href="https://www.youtube.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/e/ef/Youtube_logo.png"
            alt="YouTube Logo"
            className="h-8 w-8"
          />
        </a>
        <a
          href="https://www.instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/1200px-Instagram_icon.png"
            alt="Instagram Logo"
            className="h-8 w-8"
          />
        </a> */}
      </div>
    </footer>
  );
};

export default Footer;
